import React, { useState, useEffect } from 'react';

import { Dialog } from '@headlessui/react';

export default function DigItemOption(props) {
    const [variants, setVariants] = useState([]);
    const [addons, setAddons] = useState([]);
    const [selectedAddons, setSelectedAddons] = useState([]);

    const [selectedVariant, setSelectedVariant] = useState(0);

    const isAddonSelected = (name) => {
        return selectedAddons.some((a) => a.name === name);
    };

    const toggleAddon = (addon) => {
        if (isAddonSelected(addon.name)) {
            setSelectedAddons(selectedAddons.filter((a) => a.name !== addon.name));
        } else {
            setSelectedAddons([...selectedAddons, addon]);
        }
    };

    const handleDone = () => {
        const selVariant = variants[selectedVariant];
        let price = parseFloat(selVariant.price) || 0;
        selectedAddons.forEach((ad) => {
            price += parseFloat(ad.price) || 0;
        });
        const selectedItem = {
            id: props.item._id,
            menuid: props.item.menuid,
            name: selVariant.title,
            shortCode: props.item.shortCode,
            category: props.item.category,
            price,
            tax: selVariant.tax,
            qty: 1,
            itemtype: "variant",
            vid: selectedVariant.toString(),
            addons: selectedAddons,
            status: "none",
        };
        props.onClose(selectedItem);
    };

    useEffect(() => {
        if (props.item) {
            setVariants(props.item.variants || []);
            setAddons(props.item.addons || []);
        }
    }, [props.item]);

    return (
        <Dialog open={props.status} onClose={() => { props.onClose(null); }} className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
            <div className="relative w-full max-w-2xl h-full md:h-auto mx-auto bg-white shadow-lg rounded-md mt-10 p-4">
                <div className='flex items-center justify-between'>
                    <h3 className="text-xl font-semibold text-gray-900">
                        {props.item.name} &nbsp;
                    </h3>
                    <span className='bg-gray-200 hover:bg-gray-100 w-8 h-8 rounded-full cursor-pointer flex items-center justify-center' onClick={() => {
                        props.onClose(null);
                    }}>
                        <i className="las la-times text-sm text-black"></i>
                    </span>
                </div>
                <hr className='my-2' />
                {
                    variants.length > 0 && (
                        <div className="mb-4">
                            <h3 className="font-medium mb-1">Variants</h3>
                            {
                                variants.map((variant, index) => (
                                    <div key={index} onClick={() => setSelectedVariant(index)} className="flex justify-between items-center py-2 cursor-pointer text-sm border-b">
                                        <span>{variant.title}</span>
                                        <div className="flex items-center gap-3">
                                            <span>{variant.price} ₹</span>
                                            <input type="radio" checked={selectedVariant === index} onChange={() => setSelectedVariant(index)} />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    )
                }
                {
                    addons.length > 0 && (
                        <div className="mb-4">
                            <h3 className="font-medium mb-1">Add-ons</h3>
                            {
                                addons.map((addon, index) => (
                                    <div key={index} onClick={() => toggleAddon(addon)} className="flex justify-between items-center py-2 cursor-pointer text-sm border-b">
                                        <span>{addon.name}</span>
                                        <div className="flex items-center gap-3">
                                            <span>{addon.price} ₹</span>
                                            <input type="checkbox" checked={isAddonSelected(addon.name)} onChange={() => toggleAddon(addon)} />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    )
                }
                <div className='w-full flex items-center justify-end space-x-2'>
                    <button onClick={() => props.onClose(null)} className="w-[140px] py-2 text-prime border border-prime rounded-lg">
                        Cancel
                    </button>
                    <button onClick={handleDone} className="w-[140px] py-2 bg-prime text-white font-medium rounded-lg">
                        ADD
                    </button>
                </div>
            </div>
        </Dialog>
    )
}
